<template>
  <view class="checkbox-styled-demo">
    <view-desc>圆形选项：{{ checkboxValue }}</view-desc>
    <view class="cube-checkbox-example">
      <cube-checkbox wx:model="{{ checkboxValue }}" wx:model-prop="value">Checkbox</cube-checkbox>
    </view>

    <view-desc>方形选择框：{{ checkboxValue }}</view-desc>
    <view class="cube-checkbox-example">
      <cube-checkbox
        option="{{ option }}"
        shape="square"
        wx:model="{{ checkboxValue }}"
        wx:model-prop="value"
      >Styled Checkbox</cube-checkbox>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    option: {
      position: 'right'
    },
    checkboxValue: false
  }
})
</script>

<style lang="stylus">
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-checkbox": "@mpxjs/mpx-cube-ui/src/components/checkbox/index"
    }
  }
</script>
